<div class="app-header-container" *ngIf="!showGameScore() && showNavbar()">
  <app-navbar 
    [gameName]="gameName" 
    [gameId]="gameId"
    [tabs]="tabs" 
    [balance]="balance" 
    (closeClicked)="onCloseClicked()"
    (themeClicked)="onThemeClicked()" 
    (tabSelected)="onTabSelected($event)" 
  />
</div>
<div class="app-header-container" *ngIf="showGameScore()">
  <app-game-score  
    [gameId]="gameId"
    [gameName]="gameScoreService.gameName()"
    [gameInterfaceState]="gameScoreService.gameInterfaceState()"
    [opponent]="gameScoreService.opponent() || translocoService.translate('pages.game-component.joining-soon')"
    [opponentId]="gameScoreService.opponentId()" 
    [score]="gameScoreService.score().toString()"
    [reward]="gameScoreService.formattedReward()" 
    [countdown]="gameScoreService.countdown()" 
    [tournamentCountdown]="gameScoreService.tournamentCountdown()"
    [bountyAmount]="gameScoreService.bountyAmount()"
    (backClicked)="onBackClicked()"
    (closeClicked)="onCloseClicked()"
    (opponentClicked)="onOpponentClicked($event)"
  />
</div>

